export enum AuthMutationTypes {
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  LOGIN_FAILURE = 'LOGIN_FAILURE',
  LOGOUT = 'LOGOUT',
  REGISTER_SUCCESS = 'REGISTER_SUCCESS',
  REGISTER_FAILURE = 'REGISTER_FAILURE',
  SET_TOKEN_LEGACY = 'SET_TOKEN_LEGACY',
  UPDATE_USUARIO_ID = 'UPDATE_USUARIO_ID'
}
